import { render, staticRenderFns } from "./OctFileSelector.vue?vue&type=template&id=774ff158&scoped=true&"
import script from "./OctFileSelector.vue?vue&type=script&lang=js&"
export * from "./OctFileSelector.vue?vue&type=script&lang=js&"
import style0 from "./OctFileSelector.vue?vue&type=style&index=0&id=774ff158&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774ff158",
  null
  
)

export default component.exports